import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/********* FETCH MEMBER REJECTION REPORT START ********************* */
export const fetchMemberRejectionReport = (fetchData: any) => {
	const data = {
		MemberRejectionReportToken: fetchData,
	};
	const url = `${API_URL}FetchMemberRejectionReport`;
	return makeApiCall(url, data);
};
/********* FETCH MEMBER REJECTION REPORT END ********************* */

/********* EXPORT MEMBER REJECTION REPORT START ********************* */
export const fetchMemberRejectionReasoncount = (fetchData: any) => {
	const data = {
		MemberRejectionReasonToken: fetchData,
	};
	const url = `${API_URL}FetchMemberRejectionReasonCount`;
	return makeApiCall(url, data);
};
/********* EXPORT MEMBER REJECTION REPORT END ********************* */

/********* EXPORT MEMBER REJECTION REPORT START ********************* */
export const exportMemberRejectionExcel = (postData: any) => {
	const params = new URLSearchParams();
	params.append('ExportRejectionMembersListToken', postData);
	const url = `${API_URL}Report/Excel/MemberRejectionReportExportWithToken.php`;
	return makeFormApiCall(url, params);
};
